<div class="users-and-groups-list-page">
  <div class="users-and-groups-header">
    <div class="title">User administration</div>
    <div class="control">
      <mat-form-field class="search">
        <input
          autocomplete="off"
          matInput
          placeholder="Search"
          [(ngModel)]="searchValue"
          (input)="onSearchKeywordChange($event.target.value)"
        />
        <mat-icon matPrefix>search</mat-icon>
      </mat-form-field>
      <div class="add-menu" *ngIf="canManagePermissions() && !isFusionUIProject">
        <button
          mat-flat-button
          class="add-user"
          (click)="navigateToWizard('add_new_user_fusion_sso')"
          [matTooltip]="'No valid license available'"
          [matTooltipDisabled]="hasNumUserLicense"
          [disabled]="!hasNumUserLicense"
        >
          ADD USER
        </button>
      </div>
      <div class="add-menu ims-button" *ngIf="canManagePermissions() && isFusionUIProject">
        <button mat-flat-button color="primary" (click)="navigateToSSOApp()">MANAGE USERS</button>
      </div>
    </div>
  </div>

  <mat-tab-group class="users-tab-group" (selectedTabChange)="tabChanged($event)">
    <mat-tab label="Users">
      <div class="tab-content">
        <progress-spinner *ngIf="isLoading"></progress-spinner>
        <mat-table
          [hidden]="isLoading"
          class="user-administration-table"
          [dataSource]="usersData"
          #uSort="matSort"
          matSort
          #usersTable
          matSortActive="firstName"
          matSortDirection="asc"
        >
          <mat-header-row *matHeaderRowDef="columnsUsers"></mat-header-row>
          <mat-row
            class="clickable"
            *matRowDef="let row; columns: columnsUsers"
            [ngClass]="{ inactive: row.active === false, disabled: row.active === false }"
            (click)="goToProfile(row)"
          >
          </mat-row>
          <ng-container matColumnDef="userId">
            <mat-header-cell *matHeaderCellDef arrowPosition="before" mat-sort-header
              >User Id</mat-header-cell
            >
            <mat-cell *matCellDef="let user">
              <i class="mdi mdi-account"></i>
              {{ user.username }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="users">
            <mat-header-cell *matHeaderCellDef arrowPosition="before" mat-sort-header
              >Name</mat-header-cell
            >
            <mat-cell *matCellDef="let user"> {{ user.name }} {{ user.surname }} </mat-cell>
          </ng-container>

          <ng-container matColumnDef="groups" class="text truncated-text">
            <mat-header-cell *matHeaderCellDef>Groups</mat-header-cell>
            <mat-cell *matCellDef="let user">
              <mat-list role="list">
                <mat-list-item *ngFor="let group of user.groups">{{ group.name }}</mat-list-item>
              </mat-list>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="lastLogin">
            <mat-header-cell *matHeaderCellDef arrowPosition="before" mat-sort-header
              >Last login</mat-header-cell
            >
            <mat-cell *matCellDef="let user">
              {{ user.lastLoginDate?.date }}
              <br />
              {{ user.lastLoginDate?.time }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="registration">
            <mat-header-cell *matHeaderCellDef arrowPosition="before" mat-sort-header
              >Registration</mat-header-cell
            >
            <mat-cell *matCellDef="let user">
              {{ user.registerDate?.date }}
              <br />
              {{ user.registerDate?.time }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="actions" class="actions">
            <mat-header-cell *matHeaderCellDef>Actions</mat-header-cell>
            <mat-cell *matCellDef="let user" (click)="$event.stopPropagation()">
              <button
                mat-icon-button
                (click)="openActionsMenu(user)"
                [matMenuTriggerFor]="menuActions"
              >
                <mat-icon>more_horiz</mat-icon>
              </button>

              <mat-menu #menuActions="matMenu" [overlapTrigger]="false">
                <div class="mat-dropdown-menu-with-icons">
                  <button class="mat-menu-item-btn" mat-menu-item (click)="addUserToGroup(user)">
                    <mat-icon class="icon">people</mat-icon>
                    <span>Add to group</span>
                  </button>
                  <button
                    class="mat-menu-item-btn"
                    mat-menu-item
                    (click)="removeUserFromGroup(user)"
                  >
                    <mat-icon class="icon">people</mat-icon>
                    <span>Remove from group</span>
                  </button>
                  <button
                    class="mat-menu-item-btn"
                    *ngIf="user.active && user.id !== userAuth.data.NCI_UUID"
                    mat-menu-item
                    (click)="disableUser(user)"
                  >
                    <mat-icon class="icon">person</mat-icon>
                    <span>Disable user</span>
                  </button>
                  <button
                    class="mat-menu-item-btn"
                    *ngIf="!user.active"
                    mat-menu-item
                    (click)="enableUser(user)"
                  >
                    <mat-icon class="icon">person</mat-icon>
                    <span>Enable user</span>
                  </button>
                </div>
              </mat-menu>
            </mat-cell>
          </ng-container>
        </mat-table>
      </div>
    </mat-tab>
    <mat-tab label="Groups">
      <div class="tab-content">
        <mat-table
          class="user-administration-table"
          [dataSource]="groupsData"
          #gSort="matSort"
          matSort
        >
          <mat-header-row *matHeaderRowDef="columnsGroups"></mat-header-row>
          <mat-row *matRowDef="let row; columns: columnsGroups"></mat-row>

          <ng-container matColumnDef="name">
            <mat-header-cell *matHeaderCellDef arrowPosition="before" mat-sort-header
              >Group name</mat-header-cell
            >
            <mat-cell *matCellDef="let group"> {{ group.name }} </mat-cell>
          </ng-container>

          <ng-container matColumnDef="roles">
            <mat-header-cell *matHeaderCellDef>Permissions</mat-header-cell>
            <mat-cell *matCellDef="let group">
              <mat-list role="list">
                <mat-list-item *ngFor="let role of group.roles">
                  {{ getRoleFriendlyName(role.name) }}
                </mat-list-item>
              </mat-list>
              <div *ngIf="group?.roles?.length === 0">
                {{ getRoleFriendlyName(defaultRoleId) }}
              </div>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="count">
            <mat-header-cell *matHeaderCellDef arrowPosition="before" mat-sort-header
              >Member count</mat-header-cell
            >
            <mat-cell *matCellDef="let group"> {{ groupUsersCount(group.name) }} </mat-cell>
          </ng-container>
        </mat-table>
        <nrwl-no-data [hidden]="groupsData.filteredData.length > 0"></nrwl-no-data>
      </div>
    </mat-tab>
    <mat-tab label="Permissions">
      <div class="tab-content">
        <mat-table
          class="user-administration-table roles"
          [dataSource]="rolesData"
          #rSort="matSort"
          matSort
        >
          <mat-header-row *matHeaderRowDef="columnsRoles"></mat-header-row>
          <mat-row *matRowDef="let row; columns: columnsRoles"></mat-row>

          <ng-container matColumnDef="name">
            <mat-header-cell *matHeaderCellDef arrowPosition="before" mat-sort-header
              >Permission</mat-header-cell
            >
            <mat-cell *matCellDef="let role">
              {{ getRoleFriendlyName(role.name) }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="description">
            <mat-header-cell *matHeaderCellDef arrowPosition="before" mat-sort-header
              >Description</mat-header-cell
            >
            <mat-cell *matCellDef="let role">
              {{ getRoleDescription(role.name) }}
            </mat-cell>
          </ng-container>
        </mat-table>
        <nrwl-no-data [hidden]="rolesData.filteredData.length > 0"></nrwl-no-data>
      </div>
    </mat-tab>
  </mat-tab-group>
  <div [style.display]="showPagination ? 'block' : 'none'">
    <nrwl-paginator
      #paginator
      [totalResult]="usersData.filteredData.length"
      [pageSizeOptionData]="[20, 50, 100]"
      (nextPage)="nextPage($event)"
      showFirstLastButtons
    ></nrwl-paginator>
    <nrwl-no-data
      [hidden]="
        usersData.filteredData &&
        (usersData.filteredData.length === 0 || usersData.filteredData.length > 0)
      "
    >
    </nrwl-no-data>
  </div>
</div>
